<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);
const summary = ref('');

const canConfirm = computed(() => true);

const open = () => {
  summary.value = '';
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const handleConfirm = () => {
  emit('confirm', { summary: summary.value.trim() });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    width="md"
    :title="t('RESOLVE_SUMMARY.TITLE')"
    :description="t('RESOLVE_SUMMARY.DESCRIPTION')"
    icone="i-ph-check-circle"
    :confirm-button-label="t('RESOLVE_SUMMARY.CONFIRM')"
    :cancel-button-label="t('RESOLVE_SUMMARY.CANCEL')"
    :disable-confirm-button="!canConfirm"
    @confirm="handleConfirm"
  >
    <div class="mt-2">
      <textarea
        v-model="summary"
        :placeholder="t('RESOLVE_SUMMARY.PLACEHOLDER')"
        rows="4"
        class="advup-campo advup-campo--area"
      />
    </div>
  </Dialog>
</template>
